import React from "react";
import { Route, Routes } from "react-router-dom";

import Layout from "Layout";
import NonAuthLayout from "Layout/NonLayout";
import AuthProtected from "./AuthProtected";
import Routepage from "./allRoutes";

const RouteIndex = () => {
  const [authProtectedRoutes, publicRoutes] = Routepage();
  return (
    <React.Fragment>
      <Routes>
        {/* مسیرهای محافظت شده */}
        {authProtectedRoutes?.map((route: any, idx: any) => (
          <Route
            key={`${idx}_${Math.random()}`}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}

        {/* مسیرهای عمومی */}
        {publicRoutes?.map((route: any, idx: any) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
